import { Box, Link, Typography, useTheme } from '@mui/material';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        sx={{
          alignSelf: 'stretch',
          py: 1.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            flex: '1 1 0',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              fontSize: 14,
              fontWeight: 400,
              lineHeight: '20.02px',
              letterSpacing: '0.17px',
            }}
            component='span'
          >
            Please email{' '}
            <Link
              href='mailto:support@soopra.ai'
              sx={{
                color: 'primary.main',
                fontSize: 14,
                fontWeight: 400,
                lineHeight: '20.02px',
                letterSpacing: '0.17px',
                textDecoration: 'underline',
              }}
            >
              support@soopra.ai
            </Link>{' '}
            for subscription questions or cancellations
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          alignSelf: 'stretch',
          px: 2,
          py: 1.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant='body2'
          sx={{
            flex: '1 1 0',
            textAlign: 'center',
            color: 'text.secondary',
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '20.02px',
            letterSpacing: '0.17px',
          }}
        >
          © 2025 Soopra Inc. All rights reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
